<template>
    <button class="mt-button" :type="type" :class="colorScheme" @click="clickEvent">
      <slot></slot>
      <span class="circle" v-for="(c, index) in circles" :key="'circle' + index" :style="{left: c.left, top: c.top}"></span>
    </button>
</template>

<script>
export default {
  name: 'MtButton',
  props: [
    'type',
    'color',
    'size'
  ],
  data () {
    return {
      circles: []
    }
  },
  methods: {
    clickEvent (event) {
      this.$emit('click')

      const x = event.layerX
      const y = event.layerY

      this.circles.push({
        top: `${y}px`,
        left: `${x}px`
      })
    }
  },
  computed: {
    colorScheme () {
      if (this.color === 'primary-invent') {
        return {
          'primary-invent': true
        }
      }
      return {
        primary: true
      }
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../vars";
  .mt-button {
    border: 1px solid;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    cursor: pointer;
    position: relative;
    box-sizing: border-box;
    padding: 10px;
    overflow: hidden;
    box-shadow: -2px 4px 6px 0px #dedede;
    /*transition: all 0.2s ease-in;*/
    svg {
      pointer-events: none;
    }
    .circle {
      display: block;
      position: absolute;
      border-radius: 50%;
      pointer-events: none;
      width: 1px;
      height: 1px;
      z-index: 3;
      animation: ripple 1s ease-in;

      &:hover {
        transform: scale(1.01);
        box-shadow: 0 6px 4px darkgray;
      }
    }
    &.primary {
      border-color: $btn-c;
      background-color: $btn-c;
      .circle {
        background: radial-gradient(circle closest-side, #0992c9, #0992c9);
      }
      svg {
        fill: #FFF;
        width: 100%;
        /*height: 100%;*/
      }
      &:hover {
        background-color: #FFF;
        svg {
          fill: $btn-c;
        }
      }
    }
    &.primary-invent {
      border-color: $btn-c;
      background-color: #FFF;
      .circle {
        background: radial-gradient(circle closest-side, white, #0992c9);
      }
      svg {
        fill: $btn-c;
        width: 100%;
        /*height: 100%;*/
      }
      &:hover {
        background-color: $btn-c;
        svg {
          fill: #FFF;
        }
      }
    }
  }
  @keyframes ripple {
    0% {
      transform: scale(0, 0);
      opacity: 0;
    }
    75% {
      transform: scale(450, 450);
      opacity: 0.75;
    }
    100% {
      transform: scale(700, 700);
      opacity: 0;
    }
  }
</style>
